const figmaHeight = 935;
const figmaWidth = 1920;

export const rwidth = (width: number) => {
  return width * (window.innerWidth / figmaWidth);
};

export const rheight = (height: number) => {
  return height * (window.innerHeight / figmaHeight);
};

export const rscale = (size: number) => {
  return Math.ceil(
    size *
      Math.min(
        window.innerWidth / figmaWidth,
        Math.min(window.innerHeight / figmaHeight),
      ),
  );
};
